export enum AssignTechState {
waitingForAction = 0,
checkingValidation = 1,
awaitingConfirm = 2,
acceptedConfirm = 3
}
